import {
  DndContext,
  type DragCancelEvent,
  type DragEndEvent,
  DragOverlay,
  type DragStartEvent,
  MouseSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import type { DndLayoutProps } from './dnd-layout.types.ts';
import { Layout } from './layout.tsx';

export function DndLayout(props: DndLayoutProps) {
  const sensors = useSensors(
    useSensor(MouseSensor, {
      activationConstraint: {
        distance: 8,
      },
    })
  );

  const handleDragStart = (e: DragStartEvent) => {
    props.onDragStart(e);
  };

  const handleDragEnd = (e: DragEndEvent) => {
    props.onDragEnd(e);
  };

  const handleDragCancel = (e: DragCancelEvent) => {
    props.onDragCancel(e);
  };

  return (
    <DndContext
      sensors={sensors}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      onDragCancel={handleDragCancel}
    >
      <Layout {...props} />
      <DragOverlay>{props.renderOverlay()}</DragOverlay>
    </DndContext>
  );
}
